import { render } from "./Areal.vue?vue&type=template&id=11386f44&scoped=true"
import script from "./Areal.vue?vue&type=script&lang=js"
export * from "./Areal.vue?vue&type=script&lang=js"

import "./Areal.vue?vue&type=style&index=0&id=11386f44&lang=scss&scoped=true"

import exportComponent from "/Users/martin/www/forton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11386f44"]])

export default __exports__